import { render, staticRenderFns } from "./AddBubbleMenu.vue?vue&type=template&id=6cd8a1fc&"
import script from "./AddBubbleMenu.vue?vue&type=script&lang=js&"
export * from "./AddBubbleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports